import { IDonorConnectIncidentLog } from "./donor-connect-incident-log";

export interface IIncidentReport {
    id: number,
    centerId: number,
    centerName: string,
    candidateFirstName: string,
    candidateLastName: string,

    centerDisplayUserId: number,
    centerDisplayUserName: string,

    donorConnectGroup: number,
    donorConnectGroupName: string,

    incidentDate: string,

    incidentOriginTypeId: number,
    incidentOriginType: string,
    
    incidentCategoryTypeId: number,
    incidentCategoryType: string,

    incidentStatusId: number,
    incidentStatus: string,

    assignedMentorId: number,
    assignedMentorName:string,

    description: string,

    logs: IDonorConnectIncidentLog[],
}
